import { useState } from "react";
import axios from "axios";

const useInsertPublic = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const insertData = async (url, newData, onSuccess) => {
    setIsLoading(true);
    try {
      const response = await axios.post(url, newData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      });

      if (response.status !== 201 && response.status !== 200) {
        throw new Error("Failed to insert data.");
      }

      setResponseData(response.data);
      setSuccessMessage("success");
      setIsLoading(false);

      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message);
        setErrorMessage(error.response.data.message);
      } else if (error.request) {
        setErrorMessage("No response received from the server.");
      } else {
        setErrorMessage(error.message.data.message);
      }
      setIsLoading(false);
    }
  };

  return { insertData, isLoading, errorMessage, successMessage, responseData };
};

export default useInsertPublic;
